import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = ["type", "id"]
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "mt-2"
}

import { computed, inject } from 'vue';
    import type { AuthState, AuthMethods } from '../composables/useAuth';
    import { AUTH_STATE_KEY, AUTH_METHODS_KEY } from '../composables/authKeys';

    interface Props {
        direction: 'source' | 'dest';
        migrationType: 'Mail' | 'Contacts';
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordAuthSection',
  props: {
    direction: {},
    migrationType: {}
  },
  setup(__props: any) {

    const props = __props;

    const authState = inject(AUTH_STATE_KEY) as AuthState;
    const authMethods = inject(AUTH_METHODS_KEY) as AuthMethods;

    const serverRef = computed(() => 
        props.direction === 'source' ? authState.sourceServer : authState.destServer
    );

    const userRef = computed(() => 
        props.direction === 'source' ? authState.sourceUser : authState.destUser
    );

    const passwordRef = computed(() => 
        props.direction === 'source' ? authState.sourcePassword : authState.destPassword
    );

    const showPasswordRef = computed(() => 
        props.direction === 'source' ? authState.showSourcePassword : authState.showDestPassword
    );

    const authenticatingRef = computed(() => 
        props.direction === 'source' ? authState.sourceAuthenticating : authState.destAuthenticating
    );

    const authStatusRef = computed(() => 
        props.direction === 'source' ? authState.sourceAuthStatus : authState.destAuthStatus
    );

    const authSuccessRef = computed(() => 
        props.direction === 'source' ? authState.sourceAuthSuccess : authState.destAuthSuccess
    );

    const canAuthenticate = computed(() => {
        return serverRef.value.value && userRef.value.value && passwordRef.value.value;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: `${__props.direction}Server`,
        class: "form-label"
      }, "Server", 8 /* PROPS */, _hoisted_2),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        id: `${__props.direction}Server`,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((serverRef.value.value) = $event)),
        required: ""
      }, null, 8 /* PROPS */, _hoisted_3), [
        [_vModelText, serverRef.value.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", {
        for: `${__props.direction}User`,
        class: "form-label"
      }, "Username", 8 /* PROPS */, _hoisted_5),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        id: `${__props.direction}User`,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userRef.value.value) = $event)),
        required: ""
      }, null, 8 /* PROPS */, _hoisted_6), [
        [_vModelText, userRef.value.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", {
        for: `${__props.direction}Password`,
        class: "form-label"
      }, "Password", 8 /* PROPS */, _hoisted_8),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("input", {
          type: showPasswordRef.value.value ? 'text' : 'password',
          class: "form-control",
          id: `${__props.direction}Password`,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((passwordRef.value.value) = $event)),
          required: ""
        }, null, 8 /* PROPS */, _hoisted_10), [
          [_vModelDynamic, passwordRef.value.value]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary",
          type: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (showPasswordRef.value.value = !showPasswordRef.value.value))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(showPasswordRef.value.value ? 'bi bi-eye-slash' : 'bi bi-eye')
          }, null, 2 /* CLASS */)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline-primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(authMethods).authenticateServer(__props.direction, __props.migrationType))),
        disabled: authenticatingRef.value.value || !canAuthenticate.value
      }, [
        (authenticatingRef.value.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("span", {
                class: "spinner-border spinner-border-sm me-1",
                role: "status",
                "aria-hidden": "true"
              }, null, -1 /* CACHED */),
              _createTextVNode(" Authenticating... ", -1 /* CACHED */)
            ]))]))
          : (_openBlock(), _createElementBlock("span", _hoisted_14, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "bi bi-key" }, null, -1 /* CACHED */),
              _createTextVNode(" Authenticate ", -1 /* CACHED */)
            ]))]))
      ], 8 /* PROPS */, _hoisted_12),
      (authStatusRef.value.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("span", {
              class: _normalizeClass(authSuccessRef.value.value ? 'text-success' : 'text-danger')
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(authSuccessRef.value.value ? 'bi bi-check-circle' : 'bi bi-x-circle')
              }, null, 2 /* CLASS */),
              _createTextVNode(" " + _toDisplayString(authStatusRef.value.value), 1 /* TEXT */)
            ], 2 /* CLASS */)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})